import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "main-content" }
const _hoisted_2 = { class: "section" }
const _hoisted_3 = { class: "row mb-5 pb-5 justify-content-center" }
const _hoisted_4 = { class: "col-md-4" }
const _hoisted_5 = { class: "row p-0" }
const _hoisted_6 = { class: "col-12 p-0" }
const _hoisted_7 = { class: "card p-3 mb-4 bg-dark-gradient border-radius-10 d-block" }
const _hoisted_8 = { class: "row" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("div", { class: "col-6" }, [
  /*#__PURE__*/_createElementVNode("h5", { class: "font-white font-size-14 mt-1" }, [
    /*#__PURE__*/_createElementVNode("b", null, "Account Type")
  ]),
  /*#__PURE__*/_createElementVNode("h5", { class: "font-white font-size-12 mt-2" }, " Custodian Management ")
], -1)
const _hoisted_10 = { class: "col-6" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("h5", { class: "font-white font-size-14 mt-1" }, [
  /*#__PURE__*/_createElementVNode("b", null, "Balance")
], -1)
const _hoisted_12 = { class: "font-white font-size-12 mt-2" }
const _hoisted_13 = { class: "row mt-3" }
const _hoisted_14 = { class: "col-6" }
const _hoisted_15 = /*#__PURE__*/_createElementVNode("h5", { class: "font-white font-size-14 mt-1" }, [
  /*#__PURE__*/_createElementVNode("b", null, "Account Name")
], -1)
const _hoisted_16 = { class: "font-white font-size-12 mt-2" }
const _hoisted_17 = {
  class: "col-6",
  style: {"overflow-y":"auto","max-height":"125px"}
}
const _hoisted_18 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_19 = { class: "row mt-3" }
const _hoisted_20 = { class: "col-6 ac-last-first-c" }
const _hoisted_21 = /*#__PURE__*/_createElementVNode("h5", { class: "font-white font-size-14 mt-1" }, [
  /*#__PURE__*/_createElementVNode("b", null, "Account Reference")
], -1)
const _hoisted_22 = { class: "font-white font-size-12 mt-2" }
const _hoisted_23 = { class: "col-6 ac-last-first-c" }
const _hoisted_24 = /*#__PURE__*/_createElementVNode("h5", { class: "font-white font-size-14 mt-1" }, [
  /*#__PURE__*/_createElementVNode("b", null, "Date Account Established ")
], -1)
const _hoisted_25 = { class: "font-white font-size-12 mt-2" }
const _hoisted_26 = { class: "col-12 p-0" }
const _hoisted_27 = { class: "card p-0 bg-white border-radius-10" }
const _hoisted_28 = /*#__PURE__*/_createElementVNode("div", {
  class: "row m-0 bg-white border-bottom",
  style: {"border-radius":"10px 10px 0px 0px"}
}, [
  /*#__PURE__*/_createElementVNode("div", { class: "col-12 d-block text-center py-4" }, [
    /*#__PURE__*/_createElementVNode("h5", { class: "font-size-16 font-grey m-0" }, [
      /*#__PURE__*/_createElementVNode("b", null, "Portfolio")
    ])
  ])
], -1)
const _hoisted_29 = { class: "row my-3 justify-content-center" }
const _hoisted_30 = { class: "col-md-12 px-4 py-2" }
const _hoisted_31 = { class: "card p-2 bg-card-grey border-radius-10" }
const _hoisted_32 = { class: "row mt-3 mx-1" }
const _hoisted_33 = { class: "form-group" }
const _hoisted_34 = { class: "form-control bg-white d-flex justify-content-between p-3" }
const _hoisted_35 = { class: "width-110 font-grey font-size-12" }
const _hoisted_36 = { class: "font-grey font-size-12" }
const _hoisted_37 = { class: "font-grey font-size-12" }
const _hoisted_38 = { class: "col-md-12 p-0" }
const _hoisted_39 = { class: "form-group" }
const _hoisted_40 = {
  class: "form-control d-flex justify-content-between p-3",
  style: {"background":"#6F7F9B!important"}
}
const _hoisted_41 = /*#__PURE__*/_createElementVNode("b", { class: "width-110 font-white font-size-12" }, "Total", -1)
const _hoisted_42 = { class: "font-white font-size-12" }
const _hoisted_43 = { class: "col-md-8" }
const _hoisted_44 = { class: "p-0 bg-white border-radius-10" }
const _hoisted_45 = {
  class: "row m-0 bg-white border-bottom",
  style: {"border-radius":"10px 10px 0px 0px"}
}
const _hoisted_46 = /*#__PURE__*/_createElementVNode("div", { class: "col-md-8 d-flex py-4 justify-content-start" }, [
  /*#__PURE__*/_createElementVNode("h5", { class: "font-size-16 font-grey m-0" }, [
    /*#__PURE__*/_createElementVNode("b", null, "Transactions"),
    /*#__PURE__*/_createElementVNode("br"),
    /*#__PURE__*/_createElementVNode("p", {
      class: "font-size-12 font-gray2",
      id: "transSubTitle"
    })
  ])
], -1)
const _hoisted_47 = { class: "col-md-4 d-flex justify-content-start py-4" }
const _hoisted_48 = ["selected", "data-id", "value"]
const _hoisted_49 = ["id"]
const _hoisted_50 = {
  class: "row m-0 rm_canvas",
  style: {"border-radius":"10px 10px 0px 0px"}
}
const _hoisted_51 = { class: "col-md-12 d-flex justify-content-start pt-4 pb-3" }
const _hoisted_52 = { class: "d-flex" }
const _hoisted_53 = /*#__PURE__*/_createElementVNode("h5", { class: "font-size-16 font-grey m-0" }, [
  /*#__PURE__*/_createElementVNode("b", null, "Custodian Details")
], -1)
const _hoisted_54 = { class: "font-size-15 font-white ml-2" }
const _hoisted_55 = { class: "row px-3" }
const _hoisted_56 = { class: "col-md-12" }
const _hoisted_57 = /*#__PURE__*/_createElementVNode("span", { class: "float-left rm_canvas" }, null, -1)
const _hoisted_58 = { class: "d-flex float-right" }
const _hoisted_59 = /*#__PURE__*/_createElementVNode("p", { class: "m-0 font-size-14 p-0 font-white mr-2" }, "Asset Valuation Under Custody", -1)
const _hoisted_60 = { class: "m-0 font-size-14 p-0 font-white mr-2" }
const _hoisted_61 = { class: "row px-3 mt-2" }
const _hoisted_62 = { class: "col-7 pr-1" }
const _hoisted_63 = { class: "row p-0 m-0 w-100" }
const _hoisted_64 = /*#__PURE__*/_createElementVNode("div", { class: "col-12 p-0 m-0 d-flex align-items-center justify-content-between" }, [
  /*#__PURE__*/_createElementVNode("p", { class: "font-size-15 font-white p-1 bg-dark m-0 w-100" }, "Issuer information")
], -1)
const _hoisted_65 = /*#__PURE__*/_createElementVNode("div", { class: "col-4 font-orange p-1 font-size-12" }, "Name", -1)
const _hoisted_66 = { class: "col-8 font-white p-1 font-size-12" }
const _hoisted_67 = /*#__PURE__*/_createElementVNode("div", { class: "col-4 font-orange p-1 font-size-12" }, "Description", -1)
const _hoisted_68 = { class: "col-8 font-white p-1 font-size-12" }
const _hoisted_69 = /*#__PURE__*/_createElementVNode("div", { class: "col-4 font-orange p-1 font-size-12" }, "Industry", -1)
const _hoisted_70 = { class: "col-8 font-white p-1 font-size-12" }
const _hoisted_71 = /*#__PURE__*/_createElementVNode("div", { class: "col-4 font-orange p-1 font-size-12" }, "Issuing CSD", -1)
const _hoisted_72 = { class: "col-8 font-white p-1 font-size-12" }
const _hoisted_73 = /*#__PURE__*/_createElementVNode("div", { class: "col-4 font-orange p-1 font-size-12" }, "Registrar", -1)
const _hoisted_74 = { class: "col-8 font-white p-1 font-size-12" }
const _hoisted_75 = /*#__PURE__*/_createElementVNode("div", { class: "col-4 font-orange p-1 font-size-12" }, "Volume Units", -1)
const _hoisted_76 = { class: "col-8 font-white p-1 font-size-12" }
const _hoisted_77 = { class: "row p-0 m-0 w-100" }
const _hoisted_78 = /*#__PURE__*/_createElementVNode("div", { class: "col-12 p-0 m-0 d-flex align-items-center justify-content-between" }, [
  /*#__PURE__*/_createElementVNode("p", { class: "font-size-15 font-white p-1 bg-dark m-0 w-100" }, "Securities Information")
], -1)
const _hoisted_79 = /*#__PURE__*/_createElementVNode("div", { class: "col-4 font-orange p-1 font-size-12" }, "MKt Iss", -1)
const _hoisted_80 = { class: "col-8 font-white p-1 font-size-12" }
const _hoisted_81 = /*#__PURE__*/_createElementVNode("div", { class: "col-4 font-orange p-1 font-size-12" }, "Country", -1)
const _hoisted_82 = { class: "col-3 font-white p-1 font-size-12" }
const _hoisted_83 = /*#__PURE__*/_createElementVNode("div", { class: "col-3 font-orange p-1 font-size-12" }, "Currency", -1)
const _hoisted_84 = { class: "col-2 font-white p-1 font-size-12" }
const _hoisted_85 = /*#__PURE__*/_createElementVNode("div", { class: "col-4 font-orange p-1 font-size-12" }, "Rank", -1)
const _hoisted_86 = { class: "col-3 font-white p-1 font-size-12" }
const _hoisted_87 = /*#__PURE__*/_createElementVNode("div", { class: "col-3 font-orange p-1 font-size-12" }, "Series", -1)
const _hoisted_88 = { class: "col-2 font-white p-1 font-size-12" }
const _hoisted_89 = /*#__PURE__*/_createElementVNode("div", { class: "col-12 font-white p-1 font-size-12" }, [
  /*#__PURE__*/_createElementVNode("hr", {
    class: "my-1",
    style: {"border-top":"1px solid #343a40"}
  })
], -1)
const _hoisted_90 = /*#__PURE__*/_createElementVNode("div", { class: "col-4 font-orange p-1 font-size-12" }, "Coupon Records", -1)
const _hoisted_91 = { class: "col-8 font-white p-1 font-size-12" }
const _hoisted_92 = /*#__PURE__*/_createElementVNode("div", { class: "col-4 font-orange p-1 font-size-12" }, "Coupon Amount ", -1)
const _hoisted_93 = { class: "col-8 font-white p-1 font-size-12" }
const _hoisted_94 = /*#__PURE__*/_createElementVNode("div", { class: "col-4 font-orange p-1 font-size-12" }, "Coupon (%)", -1)
const _hoisted_95 = { class: "col-3 font-white p-1 font-size-12" }
const _hoisted_96 = /*#__PURE__*/_createElementVNode("div", { class: "col-2 font-orange p-1 font-size-12" }, "Type", -1)
const _hoisted_97 = { class: "col-3 font-white p-1 font-size-12" }
const _hoisted_98 = /*#__PURE__*/_createElementVNode("div", { class: "col-4 font-orange p-1 font-size-12" }, "Cpn Freq", -1)
const _hoisted_99 = { class: "col-8 font-white p-1 font-size-12" }
const _hoisted_100 = /*#__PURE__*/_createElementVNode("div", { class: "col-4 font-orange p-1 font-size-12" }, "Day City ", -1)
const _hoisted_101 = { class: "col-3 font-white p-1 font-size-12" }
const _hoisted_102 = /*#__PURE__*/_createElementVNode("div", { class: "col-2 font-orange p-1 font-size-12" }, "Iss Price", -1)
const _hoisted_103 = { class: "col-3 font-white p-1 font-size-12" }
const _hoisted_104 = /*#__PURE__*/_createElementVNode("div", { class: "col-4 font-orange p-1 font-size-12" }, "Maturity", -1)
const _hoisted_105 = { class: "col-8 font-white p-1 font-size-12" }
const _hoisted_106 = /*#__PURE__*/_createElementVNode("div", { class: "col-4 font-orange p-1 font-size-12" }, "Iss Sprd", -1)
const _hoisted_107 = { class: "col-8 font-white p-1 font-size-12" }
const _hoisted_108 = /*#__PURE__*/_createElementVNode("div", { class: "col-12 font-white p-1 font-size-12" }, [
  /*#__PURE__*/_createElementVNode("hr", {
    class: "my-1",
    style: {"border-top":"1px solid #343a40"}
  })
], -1)
const _hoisted_109 = /*#__PURE__*/_createElementVNode("div", { class: "col-4 font-orange p-1 font-size-12" }, "Calc Type", -1)
const _hoisted_110 = { class: "col-8 font-white p-1 font-size-12" }
const _hoisted_111 = /*#__PURE__*/_createElementVNode("div", { class: "col-8 font-orange p-1 font-size-12" }, "Announcement Date", -1)
const _hoisted_112 = { class: "col-4 font-white p-1 font-size-12" }
const _hoisted_113 = /*#__PURE__*/_createElementVNode("div", { class: "col-8 font-orange p-1 font-size-12" }, "Interest Accrual Date", -1)
const _hoisted_114 = { class: "col-4 font-white p-1 font-size-12" }
const _hoisted_115 = /*#__PURE__*/_createElementVNode("div", { class: "col-8 font-orange p-1 font-size-12" }, "1st Settle Date", -1)
const _hoisted_116 = { class: "col-4 font-white p-1 font-size-12" }
const _hoisted_117 = /*#__PURE__*/_createElementVNode("div", { class: "col-8 font-orange p-1 font-size-12" }, "1st Coupon Date", -1)
const _hoisted_118 = { class: "col-4 font-white p-1 font-size-12" }
const _hoisted_119 = { class: "col-5 pl-0" }
const _hoisted_120 = { class: "row p-0 m-0 w-100" }
const _hoisted_121 = /*#__PURE__*/_createElementVNode("div", { class: "col-12 p-0 m-0 d-flex align-items-center justify-content-between" }, [
  /*#__PURE__*/_createElementVNode("p", { class: "font-size-15 font-white p-1 bg-dark m-0 w-100" }, "Identifiers")
], -1)
const _hoisted_122 = /*#__PURE__*/_createElementVNode("div", { class: "col-4 font-orange p-1 font-size-12" }, "ID Number", -1)
const _hoisted_123 = { class: "col-8 font-white p-1 font-size-12" }
const _hoisted_124 = /*#__PURE__*/_createElementVNode("div", { class: "col-4 font-orange p-1 font-size-12" }, "ISIN", -1)
const _hoisted_125 = { class: "col-8 font-white p-1 font-size-12" }
const _hoisted_126 = /*#__PURE__*/_createElementVNode("div", { class: "col-4 font-orange p-1 font-size-12" }, "FIGI", -1)
const _hoisted_127 = { class: "col-8 font-white p-1 font-size-12" }
const _hoisted_128 = { class: "row p-0 m-0 w-100" }
const _hoisted_129 = /*#__PURE__*/_createElementVNode("div", { class: "col-12 p-0 m-0 d-flex align-items-center justify-content-between" }, [
  /*#__PURE__*/_createElementVNode("p", { class: "font-size-15 font-white p-1 bg-dark m-0 w-100" }, "Ratings")
], -1)
const _hoisted_130 = /*#__PURE__*/_createElementVNode("div", { class: "col-4 font-orange p-1 font-size-12" }, "Moody’s", -1)
const _hoisted_131 = { class: "col-8 font-white p-1 font-size-12" }
const _hoisted_132 = /*#__PURE__*/_createElementVNode("div", { class: "col-4 font-orange p-1 font-size-12" }, "S&P", -1)
const _hoisted_133 = { class: "col-8 font-white p-1 font-size-12" }
const _hoisted_134 = /*#__PURE__*/_createElementVNode("div", { class: "col-4 font-orange p-1 font-size-12" }, "Fitch", -1)
const _hoisted_135 = { class: "col-8 font-white p-1 font-size-12" }
const _hoisted_136 = /*#__PURE__*/_createElementVNode("div", { class: "col-4 font-orange p-1 font-size-12" }, "DBRS", -1)
const _hoisted_137 = { class: "col-8 font-white p-1 font-size-12" }
const _hoisted_138 = { class: "row p-0 m-0 w-100" }
const _hoisted_139 = /*#__PURE__*/_createElementVNode("div", { class: "col-12 p-0 m-0 d-flex align-items-center justify-content-between" }, [
  /*#__PURE__*/_createElementVNode("p", { class: "font-size-15 font-white p-1 bg-dark m-0 w-100" }, "Issuance & Custody")
], -1)
const _hoisted_140 = /*#__PURE__*/_createElementVNode("div", { class: "col-12 font-orange p-1 font-size-12" }, " Amt Issued/Outstanding ", -1)
const _hoisted_141 = /*#__PURE__*/_createElementVNode("div", { class: "col-4 font-white p-1 font-size-12" }, "AUD", -1)
const _hoisted_142 = { class: "col-8 font-white p-1 font-size-12" }
const _hoisted_143 = /*#__PURE__*/_createElementVNode("div", { class: "col-4 font-white p-1 font-size-12" }, "AUD", -1)
const _hoisted_144 = { class: "col-8 font-white p-1 font-size-12" }
const _hoisted_145 = /*#__PURE__*/_createElementVNode("div", { class: "col-4 font-orange p-1 font-size-12" }, " Min Piece/Increment ", -1)
const _hoisted_146 = { class: "col-8 font-white p-1 font-size-12" }
const _hoisted_147 = /*#__PURE__*/_createElementVNode("div", { class: "col-6 font-orange p-1 font-size-12" }, "Par Amount", -1)
const _hoisted_148 = { class: "col-6 font-white p-1 font-size-12" }
const _hoisted_149 = /*#__PURE__*/_createElementVNode("div", { class: "col-6 font-orange p-1 font-size-12" }, "SKR No. ", -1)
const _hoisted_150 = { class: "col-6 font-white p-1 font-size-12" }
const _hoisted_151 = /*#__PURE__*/_createElementVNode("div", { class: "col-6 font-orange p-1 font-size-12" }, "Book", -1)
const _hoisted_152 = { class: "col-6 font-white p-1 font-size-12" }
const _hoisted_153 = /*#__PURE__*/_createElementVNode("div", { class: "col-6 font-orange p-1 font-size-12" }, "Exchange", -1)
const _hoisted_154 = { class: "col-6 font-white p-1 font-size-12" }
const _hoisted_155 = /*#__PURE__*/_createElementVNode("div", { class: "col-6 font-orange p-1 font-size-12" }, "Place Of Custody", -1)
const _hoisted_156 = { class: "col-6 font-white p-1 font-size-12" }
const _hoisted_157 = /*#__PURE__*/_createElementVNode("div", { class: "col-6 font-orange p-1 font-size-12" }, "Custody Start", -1)
const _hoisted_158 = { class: "col-6 font-white p-1 font-size-12" }
const _hoisted_159 = /*#__PURE__*/_createElementVNode("div", { class: "col-6 font-orange p-1 font-size-12" }, "Custody Finish", -1)
const _hoisted_160 = { class: "col-6 font-white p-1 font-size-12" }
const _hoisted_161 = /*#__PURE__*/_createElementVNode("div", { class: "col-6 font-orange p-1 font-size-12" }, "Volume in Custody", -1)
const _hoisted_162 = { class: "col-6 font-white p-1 font-size-12" }
const _hoisted_163 = /*#__PURE__*/_createElementVNode("div", { class: "col-6 font-orange p-1 font-size-12" }, "Beneficiary", -1)
const _hoisted_164 = { class: "col-6 font-white p-1 font-size-12" }
const _hoisted_165 = /*#__PURE__*/_createElementVNode("div", { class: "col-6 font-orange p-1 font-size-12" }, "Custody Type", -1)
const _hoisted_166 = { class: "col-6 font-white p-1 font-size-12" }
const _hoisted_167 = /*#__PURE__*/_createElementVNode("div", { class: "col-6 font-orange p-1 font-size-12" }, "Custodian ", -1)
const _hoisted_168 = { class: "col-6 font-white p-1 font-size-12" }
const _hoisted_169 = { class: "row px-3 mt-2" }
const _hoisted_170 = { class: "col-12 m-0 p-0" }
const _hoisted_171 = /*#__PURE__*/_createElementVNode("hr", {
  class: "my-1",
  style: {"border-top":"1px solid #343a40"}
}, null, -1)
const _hoisted_172 = { class: "font-white text-center" }
const _hoisted_173 = /*#__PURE__*/_createElementVNode("hr", {
  class: "my-1",
  style: {"border-top":"1px solid #343a40"}
}, null, -1)
const _hoisted_174 = {
  key: 0,
  class: "justify-content-center row p-3 transaction-list",
  style: {"height":"auto"}
}
const _hoisted_175 = /*#__PURE__*/_createElementVNode("p", { class: "text-center" }, "No Custodian Found", -1)
const _hoisted_176 = [
  _hoisted_175
]
const _hoisted_177 = { class: "my-4 p-0 bg-white border-radius-10" }
const _hoisted_178 = {
  class: "row m-0",
  style: {"border-radius":"10px 10px 0px 0px"}
}
const _hoisted_179 = { class: "col-md-12 d-flex justify-content-start border-bottom align-items-center py-2" }
const _hoisted_180 = { class: "nav chart-nav justify-content-between" }
const _hoisted_181 = { class: "nav-item" }
const _hoisted_182 = { class: "nav-item" }
const _hoisted_183 = { class: "nav-item" }
const _hoisted_184 = { class: "nav-item" }
const _hoisted_185 = { class: "nav-item" }
const _hoisted_186 = {
  key: 0,
  class: "row"
}
const _hoisted_187 = {
  key: 0,
  class: "col-md-12 mt-4 pt-2 d-flex justify-content-start align-items-center chartDiv",
  id: "lastMonthDiv"
}
const _hoisted_188 = { class: "p-2 mx-auto line-chart" }
const _hoisted_189 = {
  id: "chart1",
  style: {"height":"250px"}
}
const _hoisted_190 = {
  key: 1,
  class: "col-md-12 mt-4 pt-2 justify-content-start align-items-center chartDiv",
  id: "threeMonthDiv"
}
const _hoisted_191 = { class: "p-2 mx-auto line-chart" }
const _hoisted_192 = {
  id: "chart2",
  style: {"height":"250px"}
}
const _hoisted_193 = {
  key: 2,
  class: "col-md-12 mt-4 pt-2 justify-content-start align-items-center chartDiv",
  id: "sixMonthDiv"
}
const _hoisted_194 = { class: "p-2 mx-auto line-chart" }
const _hoisted_195 = {
  id: "chart3",
  style: {"height":"250px"}
}
const _hoisted_196 = {
  key: 3,
  class: "col-md-12 mt-4 pt-2 justify-content-start align-items-center chartDiv",
  id: "yearChartDiv"
}
const _hoisted_197 = { class: "p-2 mx-auto line-chart" }
const _hoisted_198 = {
  id: "chart4",
  style: {"height":"250px"}
}
const _hoisted_199 = {
  key: 4,
  class: "col-md-12 mt-4 pt-2 justify-content-start align-items-center chartDiv",
  id: "allTimeDiv"
}
const _hoisted_200 = { class: "p-2 mx-auto line-chart" }
const _hoisted_201 = {
  id: "chart5",
  style: {"height":"250px"}
}
const _hoisted_202 = {
  key: 1,
  class: "row"
}
const _hoisted_203 = /*#__PURE__*/_createElementVNode("p", { class: "col-md-12 font-grey text-center" }, " Loading...", -1)
const _hoisted_204 = [
  _hoisted_203
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_basic = _resolveComponent("basic")!
  const _component_right_side = _resolveComponent("right-side")!
  const _component_apexchart = _resolveComponent("apexchart")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_basic),
    _createVNode(_component_right_side, {
      user_info: _ctx.user_info,
      customer_accounts: _ctx.customer_accounts
    }, null, 8, ["user_info", "customer_accounts"]),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("section", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("div", _hoisted_6, [
                _createElementVNode("div", _hoisted_7, [
                  _createElementVNode("div", _hoisted_8, [
                    _hoisted_9,
                    _createElementVNode("div", _hoisted_10, [
                      _hoisted_11,
                      _createElementVNode("h5", _hoisted_12, _toDisplayString(_ctx.default_currency) + " " + _toDisplayString(_ctx.default_currency_icon) + " " + _toDisplayString(_ctx.custodian.default_currency_balance.toLocaleString(undefined,{minimumFractionDigits: 2,maximumFractionDigits: 2})), 1)
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_13, [
                    _createElementVNode("div", _hoisted_14, [
                      _hoisted_15,
                      _createElementVNode("h5", _hoisted_16, _toDisplayString(_ctx.custodian.userac_name), 1)
                    ]),
                    _createElementVNode("div", _hoisted_17, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.all_subac, (subac) => {
                        return (_openBlock(), _createElementBlock("h5", {
                          class: "font-white font-size-12 mt-2",
                          key: subac.subac_id
                        }, [
                          _createTextVNode(_toDisplayString(subac.subac_name), 1),
                          _hoisted_18,
                          _createTextVNode(" " + _toDisplayString(subac.currency_name) + " " + _toDisplayString(subac.currency_symbol) + _toDisplayString(subac.subac_currency_balance), 1)
                        ]))
                      }), 128))
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_19, [
                    _createElementVNode("div", _hoisted_20, [
                      _hoisted_21,
                      _createElementVNode("h5", _hoisted_22, " #" + _toDisplayString(_ctx.custodian.userac_reference_code), 1)
                    ]),
                    _createElementVNode("div", _hoisted_23, [
                      _hoisted_24,
                      _createElementVNode("h5", _hoisted_25, _toDisplayString(_ctx.custodian.userac_establish_date), 1)
                    ])
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_26, [
                _createElementVNode("div", _hoisted_27, [
                  _hoisted_28,
                  _createElementVNode("div", _hoisted_29, [
                    _createElementVNode("div", _hoisted_30, [
                      _createElementVNode("div", _hoisted_31, [
                        _createElementVNode("div", _hoisted_32, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.customer_accounts, (ac) => {
                            return (_openBlock(), _createElementBlock("div", {
                              class: "col-md-12 p-0",
                              key: ac.userac_id
                            }, [
                              _createElementVNode("div", _hoisted_33, [
                                _createElementVNode("div", _hoisted_34, [
                                  _createElementVNode("b", _hoisted_35, _toDisplayString(ac.ac_name), 1),
                                  _createElementVNode("p", _hoisted_36, _toDisplayString(ac.ac_percent.toFixed()) + " % ", 1),
                                  _createElementVNode("p", _hoisted_37, _toDisplayString(_ctx.default_currency_icon) + " " + _toDisplayString(ac.default_currency_balance.toLocaleString(undefined,{minimumFractionDigits: 2,maximumFractionDigits: 2})), 1)
                                ])
                              ])
                            ]))
                          }), 128)),
                          _createElementVNode("div", _hoisted_38, [
                            _createElementVNode("div", _hoisted_39, [
                              _createElementVNode("div", _hoisted_40, [
                                _hoisted_41,
                                _createElementVNode("p", _hoisted_42, _toDisplayString(_ctx.default_currency_icon) + " " + _toDisplayString(_ctx.total_active_default_balance.toLocaleString(undefined,{minimumFractionDigits: 2,maximumFractionDigits: 2})), 1)
                              ])
                            ])
                          ])
                        ])
                      ])
                    ])
                  ])
                ])
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_43, [
            _createElementVNode("div", _hoisted_44, [
              _createElementVNode("div", _hoisted_45, [
                _hoisted_46,
                _createElementVNode("div", _hoisted_47, [
                  _createElementVNode("select", {
                    class: "text-right w-100 trans-filter",
                    id: "selected_subac_id",
                    onChange: _cache[0] || (_cache[0] = ($event: any) => (_ctx.filterCust($event)))
                  }, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.all_subac, (subac) => {
                      return (_openBlock(), _createElementBlock("option", {
                        selected: subac.subac_id == _ctx.active_subac,
                        key: subac.subac_id,
                        "data-id": 'subTitle'+subac.subac_id,
                        value: subac.subac_id
                      }, _toDisplayString(subac.subac_name) + " (" + _toDisplayString(subac.currency_name) + ") ", 9, _hoisted_48))
                    }), 128))
                  ], 32)
                ])
              ]),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.subac, (subac) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: subac.subac_id,
                  style: {"background":"#000"},
                  class: "custodian_item",
                  id: 'custodian_item_'+subac.subac_id
                }, [
                  _createElementVNode("div", _hoisted_50, [
                    _createElementVNode("div", _hoisted_51, [
                      _createElementVNode("span", _hoisted_52, [
                        _hoisted_53,
                        _createElementVNode("h5", _hoisted_54, " Time Stamp: " + _toDisplayString(_ctx.cur_time), 1)
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_55, [
                    _createElementVNode("div", _hoisted_56, [
                      _hoisted_57,
                      _createElementVNode("span", _hoisted_58, [
                        _hoisted_59,
                        _createElementVNode("p", _hoisted_60, _toDisplayString(subac.currency_symbol) + _toDisplayString(subac.custodian_asset_valuation.toLocaleString(undefined,{minimumFractionDigits: 2,maximumFractionDigits: 2})), 1)
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_61, [
                    _createElementVNode("div", _hoisted_62, [
                      _createElementVNode("div", _hoisted_63, [
                        _hoisted_64,
                        _hoisted_65,
                        _createElementVNode("div", _hoisted_66, _toDisplayString(subac.custodian_issuer_name), 1),
                        _hoisted_67,
                        _createElementVNode("div", _hoisted_68, _toDisplayString(subac.custodian_issuer_description?subac.custodian_issuer_description:''), 1),
                        _hoisted_69,
                        _createElementVNode("div", _hoisted_70, _toDisplayString(subac.custodian_issuer_industry?subac.custodian_issuer_industry:''), 1),
                        _hoisted_71,
                        _createElementVNode("div", _hoisted_72, _toDisplayString(subac.custodian_issuer_csd?subac.custodian_issuer_csd:''), 1),
                        _hoisted_73,
                        _createElementVNode("div", _hoisted_74, _toDisplayString(subac.custodian_issuer_registrar?subac.custodian_issuer_registrar:''), 1),
                        _hoisted_75,
                        _createElementVNode("div", _hoisted_76, _toDisplayString(subac.custodian_issuer_volume_units?subac.custodian_issuer_volume_units:''), 1)
                      ]),
                      _createElementVNode("div", _hoisted_77, [
                        _hoisted_78,
                        _hoisted_79,
                        _createElementVNode("div", _hoisted_80, _toDisplayString(subac.custodian_security_mkt?subac.custodian_security_mkt:''), 1),
                        _hoisted_81,
                        _createElementVNode("div", _hoisted_82, _toDisplayString(subac.custodian_id_number?subac.country_name:''), 1),
                        _hoisted_83,
                        _createElementVNode("div", _hoisted_84, _toDisplayString(subac.currency_name?subac.currency_name:''), 1),
                        _hoisted_85,
                        _createElementVNode("div", _hoisted_86, _toDisplayString(subac.custodian_security_rank?subac.custodian_security_rank:''), 1),
                        _hoisted_87,
                        _createElementVNode("div", _hoisted_88, _toDisplayString(subac.custodian_security_series?subac.custodian_security_series:''), 1),
                        _hoisted_89,
                        _hoisted_90,
                        _createElementVNode("div", _hoisted_91, _toDisplayString(subac.custodian_coupon_records?subac.custodian_coupon_records:''), 1),
                        _hoisted_92,
                        _createElementVNode("div", _hoisted_93, _toDisplayString(subac.custodian_coupon_amount?subac.custodian_coupon_amount:''), 1),
                        _hoisted_94,
                        _createElementVNode("div", _hoisted_95, _toDisplayString(subac.custodian_coupon?subac.custodian_coupon:''), 1),
                        _hoisted_96,
                        _createElementVNode("div", _hoisted_97, _toDisplayString(subac.custodian_coupon_type?subac.custodian_coupon_type:''), 1),
                        _hoisted_98,
                        _createElementVNode("div", _hoisted_99, _toDisplayString(subac.custodian_coupon_freq?subac.custodian_coupon_freq:''), 1),
                        _hoisted_100,
                        _createElementVNode("div", _hoisted_101, _toDisplayString(subac.custodian_day_city?subac.custodian_day_city:''), 1),
                        _hoisted_102,
                        _createElementVNode("div", _hoisted_103, _toDisplayString(subac.custodian_coupon_issue_price?subac.custodian_coupon_issue_price:''), 1),
                        _hoisted_104,
                        _createElementVNode("div", _hoisted_105, _toDisplayString(subac.custodian_coupon_maturity?subac.custodian_coupon_maturity:''), 1),
                        _hoisted_106,
                        _createElementVNode("div", _hoisted_107, _toDisplayString(subac.custodian_coupon_iss_sprd?subac.custodian_coupon_iss_sprd:''), 1),
                        _hoisted_108,
                        _hoisted_109,
                        _createElementVNode("div", _hoisted_110, _toDisplayString(subac.custodian_calc_type?subac.custodian_calc_type:''), 1),
                        _hoisted_111,
                        _createElementVNode("div", _hoisted_112, _toDisplayString(subac.custodian_announcement_date?subac.custodian_announcement_date:''), 1),
                        _hoisted_113,
                        _createElementVNode("div", _hoisted_114, _toDisplayString(subac.custodian_interest_accrual_date?subac.custodian_interest_accrual_date:''), 1),
                        _hoisted_115,
                        _createElementVNode("div", _hoisted_116, _toDisplayString(subac.custodian_settle1_date?subac.custodian_settle1_date:''), 1),
                        _hoisted_117,
                        _createElementVNode("div", _hoisted_118, _toDisplayString(subac.custodian_coupon1_date?subac.custodian_coupon1_date:''), 1)
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_119, [
                      _createElementVNode("div", _hoisted_120, [
                        _hoisted_121,
                        _hoisted_122,
                        _createElementVNode("div", _hoisted_123, _toDisplayString(subac.custodian_id_number?subac.custodian_id_number:''), 1),
                        _hoisted_124,
                        _createElementVNode("div", _hoisted_125, _toDisplayString(subac.custodian_isin?subac.custodian_isin:''), 1),
                        _hoisted_126,
                        _createElementVNode("div", _hoisted_127, _toDisplayString(subac.custodian_figi?subac.custodian_figi:''), 1)
                      ]),
                      _createElementVNode("div", _hoisted_128, [
                        _hoisted_129,
                        _hoisted_130,
                        _createElementVNode("div", _hoisted_131, _toDisplayString(subac.custodian_rating_moodys?subac.custodian_rating_moodys:'N/A'), 1),
                        _hoisted_132,
                        _createElementVNode("div", _hoisted_133, _toDisplayString(subac.custodian_rating_sp?subac.custodian_rating_sp:'N/A'), 1),
                        _hoisted_134,
                        _createElementVNode("div", _hoisted_135, _toDisplayString(subac.custodian_rating_fitch?subac.custodian_rating_fitch:'N/A'), 1),
                        _hoisted_136,
                        _createElementVNode("div", _hoisted_137, _toDisplayString(subac.custodian_rating_dbrs?subac.custodian_rating_dbrs:'N/A'), 1)
                      ]),
                      _createElementVNode("div", _hoisted_138, [
                        _hoisted_139,
                        _hoisted_140,
                        _hoisted_141,
                        _createElementVNode("div", _hoisted_142, _toDisplayString(subac.custodian_amount_issued?subac.custodian_amount_issued.toLocaleString(undefined,{minimumFractionDigits: 2,maximumFractionDigits: 2}):''), 1),
                        _hoisted_143,
                        _createElementVNode("div", _hoisted_144, _toDisplayString(subac.custodian_amount_outstanding?subac.custodian_amount_outstanding.toLocaleString(undefined,{minimumFractionDigits: 2,maximumFractionDigits: 2}):''), 1),
                        _hoisted_145,
                        _createElementVNode("div", _hoisted_146, _toDisplayString(subac.custodian_min_piece?subac.custodian_min_piece.toLocaleString(undefined,{minimumFractionDigits: 2,maximumFractionDigits: 2}):'') + " / " + _toDisplayString(subac.custodian_min_increment?subac.custodian_min_increment.toLocaleString(undefined,{minimumFractionDigits: 2,maximumFractionDigits: 2}):''), 1),
                        _hoisted_147,
                        _createElementVNode("div", _hoisted_148, _toDisplayString(subac.custodian_par_amount?subac.custodian_par_amount.toLocaleString(undefined,{minimumFractionDigits: 2,maximumFractionDigits: 2}):''), 1),
                        _hoisted_149,
                        _createElementVNode("div", _hoisted_150, "#" + _toDisplayString(subac.custodian_skr_no?subac.custodian_skr_no:''), 1),
                        _hoisted_151,
                        _createElementVNode("div", _hoisted_152, _toDisplayString(subac.custodian_book?subac.custodian_book:''), 1),
                        _hoisted_153,
                        _createElementVNode("div", _hoisted_154, _toDisplayString(subac.custodian_exchange?subac.custodian_exchange:''), 1),
                        _hoisted_155,
                        _createElementVNode("div", _hoisted_156, _toDisplayString(subac.custodian_custody_place?subac.custodian_custody_place:''), 1),
                        _hoisted_157,
                        _createElementVNode("div", _hoisted_158, _toDisplayString(subac.custodian_custody_start?subac.custodian_custody_start:''), 1),
                        _hoisted_159,
                        _createElementVNode("div", _hoisted_160, _toDisplayString(subac.custodian_custody_finish?subac.custodian_custody_finish:''), 1),
                        _hoisted_161,
                        _createElementVNode("div", _hoisted_162, _toDisplayString(subac.custodian_custody_volume?subac.custodian_custody_volume:''), 1),
                        _hoisted_163,
                        _createElementVNode("div", _hoisted_164, _toDisplayString(subac.custodian_custody_beneficiary?subac.custodian_custody_beneficiary:''), 1),
                        _hoisted_165,
                        _createElementVNode("div", _hoisted_166, _toDisplayString(subac.custodian_custody_type?subac.custodian_custody_type:''), 1),
                        _hoisted_167,
                        _createElementVNode("div", _hoisted_168, _toDisplayString(subac.custodian_custodian?subac.custodian_custodian:''), 1)
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_169, [
                    _createElementVNode("div", _hoisted_170, [
                      _hoisted_171,
                      _createElementVNode("div", _hoisted_172, _toDisplayString(subac.custodian_notes?subac.custodian_notes:''), 1),
                      _hoisted_173
                    ])
                  ])
                ], 8, _hoisted_49))
              }), 128)),
              (!_ctx.subac.length)
                ? (_openBlock(), _createElementBlock("div", _hoisted_174, _hoisted_176))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("div", _hoisted_177, [
              _createElementVNode("div", _hoisted_178, [
                _createElementVNode("div", _hoisted_179, [
                  _createElementVNode("ul", _hoisted_180, [
                    _createElementVNode("li", _hoisted_181, [
                      _createElementVNode("a", {
                        class: "nav-link",
                        onClick: _cache[1] || (_cache[1] = ($event: any) => (this.active_chart=1)),
                        href: "#"
                      }, [
                        _createElementVNode("b", {
                          class: _normalizeClass([{active:_ctx.active_chart==1}, "font-grey lastMonth chartBtn"])
                        }, "Last Month", 2)
                      ])
                    ]),
                    _createElementVNode("li", _hoisted_182, [
                      _createElementVNode("a", {
                        class: "nav-link",
                        onClick: _cache[2] || (_cache[2] = ($event: any) => (this.active_chart=2)),
                        href: "#"
                      }, [
                        _createElementVNode("b", {
                          class: _normalizeClass([{active:_ctx.active_chart==2}, "font-grey threeMonth chartBtn"])
                        }, "3M", 2)
                      ])
                    ]),
                    _createElementVNode("li", _hoisted_183, [
                      _createElementVNode("a", {
                        class: "nav-link",
                        onClick: _cache[3] || (_cache[3] = ($event: any) => (this.active_chart=3)),
                        href: "#"
                      }, [
                        _createElementVNode("b", {
                          class: _normalizeClass([{active:_ctx.active_chart==3}, "font-grey sixMonth chartBtn"])
                        }, "6M", 2)
                      ])
                    ]),
                    _createElementVNode("li", _hoisted_184, [
                      _createElementVNode("a", {
                        class: "nav-link",
                        onClick: _cache[4] || (_cache[4] = ($event: any) => (this.active_chart=4)),
                        href: "#"
                      }, [
                        _createElementVNode("b", {
                          class: _normalizeClass([{active:_ctx.active_chart==4}, "font-grey yearChart chartBtn"])
                        }, "Year", 2)
                      ])
                    ]),
                    _createElementVNode("li", _hoisted_185, [
                      _createElementVNode("a", {
                        class: "nav-link",
                        onClick: _cache[5] || (_cache[5] = ($event: any) => (this.active_chart=5)),
                        href: "#"
                      }, [
                        _createElementVNode("b", {
                          class: _normalizeClass([{active:_ctx.active_chart==5}, "font-grey allTime chartBtn"])
                        }, "All", 2)
                      ])
                    ])
                  ])
                ])
              ]),
              (_ctx.on_chart==1)
                ? (_openBlock(), _createElementBlock("div", _hoisted_186, [
                    (_ctx.active_chart==1)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_187, [
                          _createElementVNode("div", _hoisted_188, [
                            _createElementVNode("div", _hoisted_189, [
                              _createVNode(_component_apexchart, {
                                type: "line",
                                height: "250",
                                options: _ctx.chartOptions1,
                                series: _ctx.series1
                              }, null, 8, ["options", "series"])
                            ])
                          ])
                        ]))
                      : _createCommentVNode("", true),
                    (_ctx.active_chart==2)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_190, [
                          _createElementVNode("div", _hoisted_191, [
                            _createElementVNode("div", _hoisted_192, [
                              _createVNode(_component_apexchart, {
                                type: "line",
                                height: "250",
                                options: _ctx.chartOptions2,
                                series: _ctx.series2
                              }, null, 8, ["options", "series"])
                            ])
                          ])
                        ]))
                      : _createCommentVNode("", true),
                    (_ctx.active_chart==3)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_193, [
                          _createElementVNode("div", _hoisted_194, [
                            _createElementVNode("div", _hoisted_195, [
                              _createVNode(_component_apexchart, {
                                type: "line",
                                height: "250",
                                options: _ctx.chartOptions3,
                                series: _ctx.series3
                              }, null, 8, ["options", "series"])
                            ])
                          ])
                        ]))
                      : _createCommentVNode("", true),
                    (_ctx.active_chart==4)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_196, [
                          _createElementVNode("div", _hoisted_197, [
                            _createElementVNode("div", _hoisted_198, [
                              _createVNode(_component_apexchart, {
                                type: "line",
                                height: "250",
                                options: _ctx.chartOptions4,
                                series: _ctx.series4
                              }, null, 8, ["options", "series"])
                            ])
                          ])
                        ]))
                      : _createCommentVNode("", true),
                    (_ctx.active_chart==5)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_199, [
                          _createElementVNode("div", _hoisted_200, [
                            _createElementVNode("div", _hoisted_201, [
                              _createVNode(_component_apexchart, {
                                type: "line",
                                height: "250",
                                options: _ctx.chartOptions5,
                                series: _ctx.series5
                              }, null, 8, ["options", "series"])
                            ])
                          ])
                        ]))
                      : _createCommentVNode("", true)
                  ]))
                : _createCommentVNode("", true),
              (_ctx.on_chart==0)
                ? (_openBlock(), _createElementBlock("div", _hoisted_202, _hoisted_204))
                : _createCommentVNode("", true)
            ])
          ])
        ])
      ])
    ])
  ], 64))
}